import { createFileRoute } from '@tanstack/react-router';
import { FinanceTransactionsScreen } from '../../screens/finance/Transactions';

export const Route = createFileRoute('/finance/transactions')({
  component: FinanceTransactionsScreen,
});
